import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { CommonState, User } from '../../state';
import { getRole } from 'main/utils/rest-apis';

export const signIn = createAsyncThunk<User, User, { rejectValue: User }>(
    'common/signIn',
    async (user, { rejectWithValue }) => {
        try {
            user.role = await getRole(user.token);
            return user;
        } catch (err) {
            console.log(err)
            return rejectWithValue(user);
        }
    }
);

export const addSignInCase = (builder: ActionReducerMapBuilder<CommonState>) => {
    builder.addCase(signIn.pending, (state, action) => {
        state.loading++;
    });

    builder.addCase(signIn.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading--;
    });

    builder.addCase(signIn.rejected, (state, action) => {
        if (action.payload) {
            state.user = action.payload;
        }
        state.loading--;
    });
}
